<template>
  <v-card class="ma-2 mb-4">
    <v-toolbar :color="color" dark>
      <v-toolbar-title>
        <v-icon class="mr-3">{{ icon }}</v-icon>
        {{ header }}
      </v-toolbar-title>
      <v-spacer />
    </v-toolbar>

    <v-alert :value="projects !== null && projects.length === 0" type="info">
      {{ emptyWarning }}
    </v-alert>

    <v-list three-line v-if="projects !== null">
      <template v-for="project in projects">
        <v-list-tile :key="project.id" avatar>
          <v-list-tile-avatar>
            <v-icon
              :color="getProjectStatusColor(project)"
              :title="getProjectStatusMessage(project)"
            >
              {{ getProjectStatusIcon(project) }}
            </v-icon>
          </v-list-tile-avatar>

          <v-list-tile-content>
            <v-list-tile-title
              v-html="getTileTitle(project)"
              style="font-size: 14px"
            ></v-list-tile-title>
            <v-list-tile-title
              v-html="getAgencyContestName(project)"
            ></v-list-tile-title>
            <v-list-tile-sub-title
              v-html="getTileSubtitle(project)"
            ></v-list-tile-sub-title>
            <span>
              <v-list-tile-action-text
                v-html="getProjectStatusMessage(project)"
                class="d-inline-block"
              ></v-list-tile-action-text>
              <span
                v-if="
                  (project.status === 'PROJECT_CHANGES_REQUESTED' ||
                    project.status === 'PROJECT_CHANGES_REQUESTED') &&
                  project.detailedCorrectionCause
                "
                class="ml-1 mr-1"
              >
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon size="16" color="blue" dark v-on="on"
                      >info_outline</v-icon
                    >
                  </template>
                  <span>{{ project.detailedCorrectionCause }}</span>
                </v-tooltip>
              </span>
              <v-list-tile-action-text
                v-html="getReportStatusMessage(project)"
                class="d-inline-block"
              ></v-list-tile-action-text>
              <span
                v-if="
                  project.finalReportStatus === 'REQUESTED_CHANGES' &&
                  project.finalReportCorrectionCause
                "
                class="ml-1 mr-1"
              >
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon size="16" color="blue" dark v-on="on"
                      >info_outline</v-icon
                    >
                  </template>
                  <span>{{ project.finalReportCorrectionCause }}</span>
                </v-tooltip>
              </span>
            </span>
          </v-list-tile-content>

          <v-list-tile-action>
            <egranty-icon-button
              icon="edit"
              :color="color"
              label="Edycja"
              v-if="!project.hideFromUser"
              @click="editProject(project)"
              :disabled="!editAllowed(project)"
            />
          </v-list-tile-action>

          <slot name="extraAction" v-bind:project="project" />

          <v-list-tile-action>
            <egranty-icon-button
              icon="description"
              :color="color"
              label="Podgląd"
              v-if="!project.hideFromUser"
              @click="viewProject(project)"
            />
          </v-list-tile-action>

          <v-list-tile-action
            v-if="
              ((project.status === 'APPROVED' &&
                project.reportEditingAllowed) ||
                project.finalReportStatus === 'APPROVED') &&
              !project.hideFromUser
            "
          >
            <egranty-icon-button
              icon="insert_chart"
              :color="getFinalReportIconColor(project)"
              label="Sprawozdanie końcowe"
              @click="navigateToFinalReport(project)"
            />
          </v-list-tile-action>

          <v-list-tile-action v-if="project.canAddSignedReportFile">
            <egranty-icon-button
              icon="upload_file"
              color="primary"
              label="Dołącz podpisane sprawozdanie"
              @click="showDialog(project.id)"
            />
          </v-list-tile-action>

          <v-list-tile-action v-if="project.canDownloadSignedReportFile">
            <egranty-icon-button
              icon="file_download"
              color="primary"
              label="Pobierz podpisane sprawozdanie"
              @click="navigateToFinalReportSigned(project)"
            />
          </v-list-tile-action>

          <v-list-tile-action>
          <egranty-icon-button
            icon="ballot"
            label="Podsumowanie projektu"
            v-if="!project.hideFromUser"
             @click="showProjectSummary(project.id)"
            />
          </v-list-tile-action>

          <v-list-tile-action>
            <egranty-icon-button
              icon="delete"
              color="red"
              label="Usuń"
              :disabled="project.status !== 'NEW'"
              v-if="!project.hideFromUser"
              @click="deleteProject(project.id)"
            />
          </v-list-tile-action>
        </v-list-tile>
      </template>
    </v-list>
    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-form ref="form">
          <v-card-title class="headline"
            >Dodawanie podpisanego sprawozdania</v-card-title
          >
          <v-card-text>
            <span class="caption" style="display: block;">
              <b> Dodaj plik z podpisanym sprawozdaniem końcowym.</b>
            </span>
            <span class="caption" style="display: block;">
              <b> Uwaga: zapisanego pliku nie będzie można skasować.</b>
            </span>
            <input
              type="file"
              :accept="acceptedFiles"
              v-show="false"
              ref="signedFinalReport"
              id="signedFinalReport"
              v-on:change="addSignedReportFile"
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn @click="$refs.signedFinalReport.click()"> Dodaj plik </v-btn>
            <v-btn @click="dialog = false"> Zamknij </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="confirmationDialog" max-width="500">
      <v-card>
        <v-card-title>
          <span class="headline">Dodawanie podpisanego sprawozdania</span>
        </v-card-title>
        <v-card-text>
          <span class="caption" style="display: block;">
              <b> Dodaj plik z podpisanym sprawozdaniem końcowym.</b>
            </span>
            <span class="caption" style="display: block;">
              <b> Uwaga: zapisanego pliku nie będzie można skasować.</b>
            </span>
          <div v-if="this.$refs.signedFinalReport" class="mt-2 ml-3">
            <div
              v-for="(item, index) in this.$refs.signedFinalReport.files"
              :key="index"
            >
              {{ item.name }}
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn @click="handleFileUpload"> Dodaj plik </v-btn>
          <v-btn @click="cancelUpload"> Anuluj </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import EgrantyIconButton from "../../../../genericComponents/EgrantyIconButton";
import { AgencyProject } from "@/api/generated/AgencyProject";
import { Files } from "@/utils/Files";

export default {
  name: "AgencyAgencyProjectsList",

  components: { EgrantyIconButton },

  props: {
    header: String,
    icon: { type: String, default: "mail" },
    emptyWarning: String,
    color: { type: String, default: "teal" },
  },
  mixins: [Files],
  data() {
    return {
      dialog: false,
      projectId: undefined,
      projects: [],
      acceptedFiles: ".pdf,.zip",
      confirmationDialog: false
    };
  },
  methods: {
    async handleFileUpload() {
      this.confirmationDialog = false;
      let formData = new FormData();
      formData.append("file", this.$refs.signedFinalReport.files[0]);
      await this.$http.post(process.env.VUE_APP_API_URL + "/agencyProject/signed-report-file?projectId="
        .concat(this.projectIdInDialog), formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      this.refresh();
    },
    cancelUpload() {
      Files.methods.clearFileInput("signedFinalReport");
      this.confirmationDialog = false;
    },
    getAgencyContestName(project) {
      return project.contestName;
    },

    getTileTitle(project) {
      return project.title;
    },

    getTileSubtitle(project) {
      let ret = "[" + project.code + "] | ";
      return !project.supervisorName ? ret + "Nie przydzielono opiekuna" : ret + "Opiekun: " + project.supervisorName;
    },

    getProjectStatusIcon(project) {
      if (this.editingVisible) {
        return project.editAllowed ? "lock_open" : "lock";
      } else {
        switch (project.status) {
          case "NEW":
            return "edit";
          case "SUBMITTED":
            return "check";
          case "REJECTED":
            return "block";
          case "AWAITING_CORRECTION":
            return "build";
          case "APPROVED":
          case "PROJECT_CHANGES_REQUESTED":
          case "FINISHED":
          case "ANNULLED":
            return "business";
        }
      }
    },

    getProjectStatusMessage(project) {
      switch (project.status) {
        case "NEW":
          return "Wniosek w trakcie uzupełniania";
        case "SUBMITTED":
          return "Wniosek wysłany";
        case "REJECTED":
          return "Wniosek odrzucony".concat(project.rejectCause ? (": " + project.rejectCause) : "");
        case "AWAITING_CORRECTION":
          return "Wniosek oczekuje na poprawki".concat(project.correctionCause ? (": " + project.correctionCause) : "");
        case "PROJECT_CHANGES_REQUESTED":
          return "Projekt oczekuje na poprawki".concat(project.correctionCause ? (": " + project.correctionCause) : "");
        case "APPROVED":
          return "Wniosek zaakceptowany";
        case "FINISHED":
          return "Projekt zakończony";
        case "ANNULLED":
          return "Projekt anulowany";
        default:
          return "";
      }
    },

    getReportStatusMessage(project) {
      if (project.status === "ANNULLED" || !this.getProjectStatusMessage(project)) {
        return "";
      }

      switch (project.finalReportStatus) {
        case "NEW":
          return "; Sprawozdanie niezłożone";
        case "SENT":
        case "CHANGES_SENT":
          return "; Sprawozdanie wysłane";
        case "APPROVED":
          return "; Sprawozdanie zatwierdzone";
        case "REQUESTED_CHANGES":
          return "; Sprawozdanie oczekuje na poprawki";
        default:
          return "";
      }
    },

    getProjectStatusColor(project) {
      switch (project.status) {
        case "NEW":
          return "teal lighten-3";
        case "SUBMITTED":
          return "green";
        case "REJECTED":
        case "ANNULLED":
          return "red";
        case "AWAITING_CORRECTION":
        case "PROJECT_CHANGES_REQUESTED":
          return "orange darken-3";
        case "APPROVED":
        case "FINISHED":
          return "blue";
      }
    },

    getFinalReportIconColor(project) {
      return project.finalReportStatus === "REQUESTED_CHANGES" ?
        "orange darken-3" : "blue";
    },

    editAllowed(project) {
      return project.status === "PROJECT_CHANGES_REQUESTED";
    },

    editProject(project) {
      this.$router.push("/app/agency-contest/" + project.contestId + "/project/" + project.id);
    },

    viewProject(project) {
      this.$router.openInNewTab("/view/agency-contest/" + project.contestId + "/project/" + project.agencyId + "/" + project.id);
    },

    navigateToFinalReport(project) {
      if (!project.reportEditingAllowed || project.status === 'FINISHED') {
        this.$router.openInNewTab({ path: "/view/agency-contest/" + project.contestId + "/final-report/" + project.id });
      } else this.$router.openInNewTab({ path: "/app/agency-contest/" + project.contestId + "/project-panel/" + project.id + "/final-report/form" });
    },

    deleteProject(projectId) {
      this.$confirm("Czy na pewno chcesz usunąć wniosek?", {
        color: "lightred",
        icon: "delete",
        title: "Usunięcie wniosku",
        width: 500
      })
        .then(res => {
          if (res) {
            AgencyProject.delete(this, projectId, successResponse => {
              this.$emit("project-removed", projectId);
              this.$messagesBus.$emit("success", "Wniosek został pomyślnie usunięty", successResponse);
            },
              errorResponse => {
                this.$messagesBus.$emit("error", "Nie udało się usunąć wniosku", errorResponse);
              });
          }
        });
    },
    showDialog(projectId) {
      Files.methods.clearFileInput('signedFinalReport');
      this.dialog = true;
      this.projectIdInDialog = projectId;
    },
    async navigateToFinalReportSigned(item) {
      await this.downloadFileAsBlob(this, this.getAgencyProjectSignedProjectFile(item.id), item.signedReportFileName);
    },
    async addSignedReportFile() {
      if (this.hasIncorrectFilesExtension(this.$refs.signedFinalReport.files)) {
        Files.methods.clearFileInput('signedFinalReport');
        this.$messagesBus.$emit("error", "Wgrywanie plików w tym formacie jest niedozwolone. " +
          "Dozwolone formaty plików to " + this.acceptedFiles.split(",").join(", "));
        return;
      }
      let validFilesSize = await Files.methods.validateFilesSize(this, this.$refs.signedFinalReport.files);
      if (!validFilesSize) {
        Files.methods.clearFileInput('signedFinalReport');
        return;
      }
      this.confirmationDialog = true;
      this.dialog = false;
    },
    refresh() {
      AgencyProject.getApprovedProjectsByAgency(this, response => {
        this.projects = response;
      });
    },
    showProjectSummary(projectId) {
      this.$router.push("/app/agency-project/" + projectId + "/summary/");
    },
  },
  created() {
    this.refresh();
  },
};
</script>